import { useTranslation } from 'react-i18next'

import { Text } from '@reveni-io/reveni-ui'

import TopicRow from '../TopicRow/TopicRow'
import { splitTopics } from './helpers'
import * as Styles from './styles'

const TopTopicsList = ({ topics, onClickTopic }) => {
  const { t } = useTranslation()

  const { namedTopics, otherTopic } = splitTopics(topics)

  if (namedTopics.length === 0 && !otherTopic) return null

  return (
    <Styles.Container>
      <Styles.Header>
        <Text type="bodySMedium">{t('Principales temas detectados')}</Text>
      </Styles.Header>

      <Styles.Rows>
        {namedTopics.map(topic => (
          <TopicRow key={topic.topic_id} topic={topic} onClick={onClickTopic} />
        ))}
        {otherTopic && <TopicRow key={otherTopic.topic_id} topic={otherTopic} onClick={onClickTopic} />}
      </Styles.Rows>
    </Styles.Container>
  )
}

export default TopTopicsList
